@import '~style-sheet-helpers/core.less';
@import '../../../../../constants/spacing.module.less';

.list-item() {
  display: flex;
  padding: @space-8;
  font-size: 14px;
  line-height: 20px;
}

.cost-breakdown {
  height: 100%;
  width: 100%;
  padding: 16px;

  border-left: 1px var(--default--border-color--6) solid;

  > h4 {
    margin: 0 0 8px;
    line-height: 20px;
    font-weight: @semi-bold;
  }

  .line-item {
    .list-item();
    justify-content: space-between;
    border-bottom: 1px var(--default--border-color--6) solid;
  }

  .adjustment-reason {
    .list-item();
    align-items: center;
    background-color: var(--blue-200);
    border: 1px var(--blue-400) solid;
    margin: @space-8 @space-0;
  }

  .total {
    padding: 8px;

    font-size: 14px;
    line-height: 20px;
    font-weight: @semi-bold;
    text-align: right;
    > span {
      padding-right: 8px;
    }
  }
}
